export type Tone = 'muted' | 'info' | 'success' | 'warning' | 'destructive' | 'neutral';

const TONE_CLASS_NAME: Readonly<Record<Tone, string>> = {
  muted: 'border-transparent bg-muted text-muted-foreground',
  info: 'border-transparent bg-secondary text-secondary-foreground',
  success:
    'border-transparent bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
  warning:
    'border-transparent bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  destructive: 'border-transparent bg-destructive/15 text-destructive',
  neutral: 'border-transparent bg-secondary text-secondary-foreground',
};

export function statusToneClassName(tone: Tone): string {
  return TONE_CLASS_NAME[tone];
}
